var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { v4 as uuidv4 } from 'uuid';
let DinapsisPreviewUploader = class DinapsisPreviewUploader extends LitElement {
    constructor() {
        super(...arguments);
        /**
         * A property that is used to set the preview container unique id
         */
        this.previewId = `uploader-preview-container-${uuidv4()}`;
        /**
         * A property that is used to contains a list
         * of file extension that are allowed for previeweing
         */
        this.allowedFilePreviewExtensions = [
            'jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'ico',
            'jfif', 'pjpeg', 'pjp', 'apng', 'avif', 'tif', 'tiff',
        ];
        /**
         * A property that is used to set the preview url
         */
        this.filePreview = undefined;
    }
    /**
     * The createRenderRoot function is a function that is called by the lit-html library to tell the
     * component where to render the html.
     * @returns The element itself.
     */
    createRenderRoot() {
        return this;
    }
    /**
     * The above function is a lifecycle hook that is called when the component is updated.
     * It is used to initialize the preview.
     */
    updated(changedProperties) {
        if (changedProperties.has('filePreview')) {
            // Update image preview
            this.setPreviewFileUrl();
        }
    }
    /**
     * This function sets the background image of an HTML element to a specified file preview URL.
     */
    setPreviewFileUrl() {
        // Get preview containers
        const previewContainer = document.getElementById(this.previewId);
        const imgPreview = previewContainer.querySelector('.img-preview');
        // If not exist filePreview set to class not-file-url which shows the default preview
        if (!this.filePreview) {
            this.setClearPreview(imgPreview);
            return;
        }
        const { fileExtension } = this.filePreview;
        const isTypeValid = this.allowedFilePreviewExtensions.includes(fileExtension);
        if (!isTypeValid) {
            this.setClearPreview(imgPreview);
            return;
        }
        // Remove class if had it
        imgPreview.classList.remove('not-file-url');
        // Set the file preview
        imgPreview.style.background = `url('${this.filePreview.url}') no-repeat center center`;
    }
    /**
     * The function removes the file default class from an HTML element and clears its
     * background style.
     * @param {HTMLElement} imgPreview - The `imgPreview` parameter is an HTMLElement representing an
     * image preview element.
     */
    setClearPreview(imgPreview) {
        imgPreview.classList.add('not-file-url');
        // eslint-disable-next-line no-param-reassign
        imgPreview.style.background = '';
    }
    /**
     * The function returns a string of HTML that contains a div that contains the component.
     * @returns The return statement is returning the html template literal
     */
    render() {
        return html `
      <div id="${this.previewId}" class="dinapsis-preview-uploader">
        <div class="img-preview"></div>
      </div>
    `;
    }
};
__decorate([
    property({ type: Object })
], DinapsisPreviewUploader.prototype, "filePreview", void 0);
DinapsisPreviewUploader = __decorate([
    customElement('dinapsis-preview-uploader')
], DinapsisPreviewUploader);
export { DinapsisPreviewUploader };
//# sourceMappingURL=dinapsis-preview-uploader.js.map